"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueSelect = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
var react_1 = tslib_1.__importDefault(require("react"));
var PureInput_1 = require("./PureInput");
var SingleValueSelect_1 = require("./SingleValueSelect");
var MultipleValueSelect_1 = require("./MultipleValueSelect");
var Loading_1 = require("./Loading");
var Empty_1 = require("./Empty");
var dropdown_1 = require("../../dropdown");
var ValueSelect = /** @class */ (function (_super) {
    tslib_1.__extends(ValueSelect, _super);
    function ValueSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mount = false;
        _this.operationalKeyDownListener = function (_) { };
        _this.state = {
            values: _this.props.values,
        };
        _this.handleKeyDown = function (keyCode) {
            if (_this["select"] && _this["select"].handleKeyDown) {
                return _this["select"].handleKeyDown(keyCode);
            }
            return true;
        };
        _this.handleKeyDownForRenderMode = function (operationalKey) {
            if (_this.props.render) {
                _this.operationalKeyDownListener(operationalKey);
            }
            return true;
        };
        return _this;
    }
    ValueSelect.prototype.componentDidMount = function () {
        var _this = this;
        this.mount = true;
        var propsValues = this.props.values;
        if (typeof propsValues === "function") {
            var res = propsValues();
            // Promise
            if (res && "then" in res) {
                res.then(function (values) {
                    _this.mount && _this.setState({ values: values });
                });
            }
            else {
                this.mount && this.setState({ values: res });
            }
        }
    };
    ValueSelect.prototype.componentWillUnmount = function () {
        this.mount = false;
    };
    // handleKeyUp = (keyCode: number): boolean => {
    //   if (this['select'] && this['select'].handleKeyUp) {
    //     return this['select'].handleKeyUp(keyCode);
    //   }
    //   return true;
    // }
    ValueSelect.prototype.render = function () {
        var _this = this;
        var values = this.state.values;
        var _a = this.props, type = _a.type, inputValue = _a.inputValue, onChange = _a.onChange, onSelect = _a.onSelect, onCancel = _a.onCancel, offset = _a.offset, maxHeight = _a.maxHeight, render = _a.render;
        var props = {
            values: values,
            inputValue: inputValue,
            onChange: onChange,
            onSelect: onSelect,
            onCancel: onCancel,
            offset: offset,
            maxHeight: maxHeight,
        };
        if (render) {
            return (react_1.default.createElement(dropdown_1.DropdownBox, { style: { marginLeft: offset }, onClick: function (e) { return e.stopPropagation(); } }, render({
                onOperationalKeyDown: function (listener) {
                    _this.operationalKeyDownListener = listener;
                },
                inputValue: inputValue,
                onSelect: onSelect,
                onCancel: onCancel,
            })));
        }
        var typeOptions;
        if (Array.isArray(type)) {
            typeOptions = type;
        }
        else {
            typeOptions = [type, {}];
        }
        if (typeOptions[0] === "input") {
            return react_1.default.createElement(PureInput_1.PureInput, tslib_1.__assign({ ref: function (select) { return (_this["select"] = select); } }, props));
        }
        if (typeOptions[0] === "single") {
            var componentOptions = typeOptions[1];
            if (!Array.isArray(values)) {
                return react_1.default.createElement(Loading_1.Loading, { offset: offset });
            }
            if (!values.length) {
                return (react_1.default.createElement(Empty_1.Empty, tslib_1.__assign({}, componentOptions, { offset: offset, onCancel: onCancel })));
            }
            return (react_1.default.createElement(SingleValueSelect_1.SingleValueSelect, tslib_1.__assign({}, props, componentOptions, { ref: function (select) { return (_this["select"] = select); }, values: values })));
        }
        if (typeOptions[0] === "multiple") {
            var componentOptions = typeOptions[1];
            if (!Array.isArray(values)) {
                return react_1.default.createElement(Loading_1.Loading, { offset: offset });
            }
            if (!values.length) {
                return (react_1.default.createElement(Empty_1.Empty, tslib_1.__assign({}, componentOptions, { offset: offset, onCancel: onCancel })));
            }
            return (react_1.default.createElement(MultipleValueSelect_1.MultipleValueSelect, tslib_1.__assign({}, props, componentOptions, { ref: function (select) { return (_this["select"] = select); }, values: values })));
        }
        return null;
    };
    return ValueSelect;
}(react_1.default.Component));
exports.ValueSelect = ValueSelect;
//# sourceMappingURL=ValueSelect.js.map